<template>
  <div class="legal-page">
    <section class="legal-hero">
      <div class="container">
        <p class="eyebrow">LEGAL</p>
        <h1>Legal Information</h1>
      </div>
    </section>

    <section class="legal-content">
      <div class="container content-card">
        <article class="legal-section">
          <p>
            Copyright &copy;2025&ndash;2026 GLOBAL AI LINK LIMITED and its
            affiliates and licensors. All rights are expressly reserved.
          </p>
          <p>
            The AI system programs, advertising operation tools, tracking system
            codes, official website content and accompanying operation
            documentation are the copyrighted property of their respective
            owners and protected by copyright laws and international
            intellectual property treaties.
          </p>
          <p>
            GlobalAI Analytics&trade;, Global MediaBuy Dashboard&trade;,
            Cross-border LeadGen Tool&trade;, AI Campaign Optimizer&trade;,
            Compliance Audit System&trade;, Ad Traffic Tracker&trade;, Prelander
            Builder&trade;, Global Ad Hub&trade; and all related product and
            service names, design marks and slogans are the trademarks and/or
            registered trademarks of GLOBAL AI LINK LIMITED and its affiliates
            and/or its licensors.
          </p>
          <p>
            Unless otherwise stated in our end-user or other product-specific
            licensing agreements, GLOBAL AI LINK LIMITED is the sole developer
            and copyright holder of all AI advertising technologies, media-buy
            tools, campaign management systems and business services listed at
            this website.
          </p>
          <p>
            All other product and service marks contained herein including
            Facebook, TikTok, Taboola, Voluum, Clickflare are the trademarks of
            their respective owners. Any use of GLOBAL AI LINK LIMITED&rsquo;s
            and/or its affiliates&rsquo; or third parties&rsquo; trademarks or
            logos without the prior written consent of their respective owners
            is strictly prohibited.
          </p>
        </article>

        <article class="legal-section">
          <h2>Contact</h2>
          <p>
            For any question about above context statements for copyrights,
            please reach us as follows:
          </p>

          <h3>General Information</h3>
          <ul class="contact-list">
            <li>
              <strong>Office Address:</strong>
              RM 101A, 1/F., GENPLAS IND BUILDING, 56 HOI YUEN ROAD, KWUN TONG,
              HONG KONG
            </li>
            <li>
              <strong>Business Hours:</strong>
              Monday to Friday, 09:00 &ndash; 19:00 (GMT+8, Hong Kong Time)
            </li>
            <li>
              <strong>Official Website:</strong>
              <a
                href="https://www.globalailink.org"
                target="_blank"
                rel="noopener noreferrer"
                >https://www.globalailink.org</a
              >
            </li>
            <li>
              <strong>Tel:</strong>
              <a href="tel:+85251719054">+852-51719054</a>
            </li>
            <li>
              <strong>Legal Entity:</strong>
              GLOBAL AI LINK LIMITED
            </li>
          </ul>

          <h3>Business &amp; Support</h3>
          <ul class="contact-list">
            <li>
              <strong>Business Cooperation:</strong>
              <a href="mailto:bd@globalailink.org">bd@globalailink.org</a>
            </li>

            <li>
              <strong>Search Arbitrage Business:</strong>
              <a href="mailto:bd-searcharbitrage@globalailink.org"
                >bd-searcharbitrage@globalailink.org</a
              >
            </li>
            <li>
              <strong>Lead Generation (CPL):</strong>
              <a href="mailto:bd-cpl@globalailink.org"
                >bd-cpl@globalailink.org</a
              >
            </li>

            <li>
              <strong>Technical Support:</strong>
              <a href="mailto:support@globalailink.org"
                >support@globalailink.org</a
              >
            </li>
            <li>
              <strong>Tel:</strong>
              <a href="tel:+85251719054">+852-51719054</a>
            </li>
            <li>
              <strong>Office Address:</strong>
              RM 101A, 1/F., GENPLAS IND BUILDING, 56 HOI YUEN ROAD, KWUN TONG,
              HONG KONG
            </li>
            <li>
              <strong>Business Hours:</strong>
              Monday to Friday, 09:00 &ndash; 19:00 (GMT+8, Hong Kong Time)
            </li>
            <li>
              <strong>Official Website:</strong>
              <a
                href="https://www.globalailink.org"
                target="_blank"
                rel="noopener noreferrer"
                >https://www.globalailink.org</a
              >
            </li>
            <li>
              <strong>Legal Entity:</strong>
              GLOBAL AI LINK LIMITED
            </li>
          </ul>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "LegalInformationPage",
};
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background-image: url("../../../static/images/publisher/hero-bg.jpg");
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-color: #f0f7ff;
  color: #1c2b4e;
}

.container {
  max-width: 960px;
  margin: 0 auto;
  padding: 0 20px;
}

.legal-hero {
  padding: 140px 0 32px;
  text-align: center;
}

.eyebrow {
  margin: 0 0 10px;
  font-size: 13px;
  letter-spacing: 1.6px;
  color: #4b89ff;
  font-weight: 700;
}

.legal-hero h1 {
  margin: 0;
  font-size: 44px;
  line-height: 1.2;
}

.legal-content {
  padding: 0 0 90px;
}

.content-card {
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(75, 137, 255, 0.12);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(28, 43, 78, 0.08);
  padding: 36px 40px;
}

.legal-section {
  margin-bottom: 28px;
}

.legal-section:last-child {
  margin-bottom: 0;
}

.legal-section p + p {
  margin-top: 12px;
}

.legal-section h2 {
  margin: 0 0 12px;
  font-size: 22px;
  line-height: 1.35;
}

.legal-section h3 {
  margin: 24px 0 12px;
  font-size: 18px;
  line-height: 1.4;
  color: #1c2b4e;
}

.legal-section p {
  margin: 0;
  font-size: 16px;
  line-height: 1.8;
  color: #475569;
}

.contact-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.contact-list li {
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 1.8;
  color: #475569;
}

.contact-list li:last-child {
  margin-bottom: 0;
}

.contact-list strong {
  color: #334155;
  font-weight: 600;
}

.legal-section a {
  color: #296dff;
  text-decoration: none;
}

.legal-section a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .legal-hero {
    padding-top: 116px;
  }

  .legal-hero h1 {
    font-size: 32px;
  }

  .content-card {
    padding: 24px 20px;
  }

  .legal-section h2 {
    font-size: 20px;
  }

  .legal-section h3 {
    font-size: 17px;
  }
}
</style>
